module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"started":"距开始","ended":"距结束","hour":"时","minute":"分"},"zh_hk":{"started":"距開始","ended":"距結束","hour":"時","minute":"分"},"en":{"started":"start:","ended":"end:","hour":"h","minute":"min left"},"ja":{"started":"開始まで","ended":"終了まで","hour":"時","minute":"分"}}')
  delete Component.options._Ctor
}
